<div class="relatorio">
  <div class="page-full section">
    <div class="d-flex justify-content-end">
      <img class="apm-logo" src="assets/images/SMG_colorfull.png">
    </div>
    <hr>
    <app-apresentacao-pauta [print]="true"></app-apresentacao-pauta>
  </div>
  
  <div class="page-break section">
    <app-apresentacao-quadro-geral [print]="true"></app-apresentacao-quadro-geral>
  </div>
  <div class="page-break section">
    <app-apresentacao-projetos [print]="true"></app-apresentacao-projetos>
  </div>
  <div class="page-break-2">
    <div class="page-break-2 section" *ngFor="let agency of this.agencys; let i = index">
      <ng-container *ngFor="let indicator of agency.indicators; let i2 = index">
        <div class="section-ind">
          <h3 *ngIf="i == 0 && i2 == 0">Projetos</h3>
          <ng-container  *ngIf="indicator?.index == 0">
            <div class="divAgency"  *ngIf="i2 == 0">
              <b>{{agency?.str_sigla}}</b> - {{agency?.str_nome}}
            </div>
            
            <div class="divProject">
              <b>{{indicator?.project?.title}}</b>
            </div>
            <app-apresentacao-slide-modal 
              [currentIndicator]="indicator" 
              titleId="managerProject" 
              [filters]="null" 
              [print]="true" 
              (closeModal)="null">
            </app-apresentacao-slide-modal>
            <br>
            <app-apresentacao-slide-modal 
              [currentIndicator]="indicator" 
              titleId="executionProject" 
              [filters]="null" 
              [print]="true" 
              (closeModal)="null">
            </app-apresentacao-slide-modal>
          </ng-container>
          <hr class="hr-indicator">
          <div class="indicator-div row g-0 mt-2">
            <div class="col-12 ps-2">
              <div class="d-flex">
                <span class="indicator-count"> Indicador {{indicator?.index + 1}} de {{indicator?.project?.pf_indicator.length}}</span>
              </div>
              <h3> {{indicator?.title}}</h3>
            </div>
          </div>
          <app-apresentacao-slide-modal 
            [currentIndicator]="indicator" 
            titleId="managerIndicator" 
            [filters]="null" 
            [print]="true" 
            (closeModal)="null">
          </app-apresentacao-slide-modal>
          <br>
          <app-apresentacao-slide-modal 
            [currentIndicator]="indicator" 
            titleId="executionIndicator" 
            [filters]="null" 
            [print]="true" 
            (closeModal)="null">
          </app-apresentacao-slide-modal>
          <app-apresentacao-slide id='ind_{{indicator?.project?.slide + indicator?.index}}' [slideIndex]="indicator?.project?.slide + indicator?.index" [print]="true"></app-apresentacao-slide>
          
        </div>
      </ng-container>
    </div>
  </div>
  <!--<div class="page-break section">
    <app-apresentacao-demandas [print]="true"></app-apresentacao-demandas>
  </div>-->
  <div class="page-break section">
    <app-apresentacao-registro [print]="true"></app-apresentacao-registro>
  </div>
</div>